import React, { useCallback, useMemo } from 'react';
import { TouchableHighlight, View } from 'react-native';
import { useAppDispatch } from 'store/hooks';
import { rem } from 'design-system';
import Amount from 'design-system/Amount';
import EmojiText from 'design-system/EmojiText';
import IconCircle from 'design-system/icons/IconCircle';
import IconEmmaWallet from 'design-system/icons/IconEmmaWallet';
import SectionHeader from 'design-system/SectionHeader';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { AccountTypeDisplay } from 'features/invest/constants';
import { setSelectedTradingAccountId } from 'actions/invest';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const WealthPotRow = ({ item }) => {
    const navigation = useMainStackNavigation();
    const colors = useColors();
    const styles = useStyles(styleSet);
    const borderStyles = useMemo(() => [
        item.isFirstInSection && styles.firstItem,
        item.isLastInSection && styles.lastItem,
    ], [
        styles.firstItem,
        styles.lastItem,
        item.isFirstInSection,
        item.isLastInSection,
    ]);
    const handlePress = useCallback(() => {
        navigation.navigateDeprecated('Pot', {
            screenParams: item.pot,
            hideSpaceUserAvatar: true,
        });
    }, [item.pot]);
    return (<View style={[styles.wrapper, borderStyles]}>
      <TouchableHighlight activeOpacity={1} style={borderStyles} onPress={handlePress} underlayColor={colors.background.underlay}>
        <View style={styles.row}>
          <IconCircle width={44} height={44}>
            <EmojiText fontSize={20}>{item.pot.emoji}</EmojiText>
          </IconCircle>
          <View style={styles.flex}>
            <Text Text-16 numberOfLines={1}>
              {item.pot.name}
            </Text>
            {!!item.potProductName && (<Text TextThin-14 Secondary>
                {item.potProductName}
              </Text>)}
          </View>
          <Amount Numbers-16 value={item.pot.balance}/>
        </View>
      </TouchableHighlight>
    </View>);
};
const WealthInvestAccountRow = ({ item, }) => {
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const colors = useColors();
    const styles = useStyles(styleSet);
    const borderStyles = useMemo(() => [
        item.isFirstInSection && styles.firstItem,
        item.isLastInSection && styles.lastItem,
    ], [
        styles.firstItem,
        styles.lastItem,
        item.isFirstInSection,
        item.isLastInSection,
    ]);
    const onPress = React.useCallback(() => {
        dispatch(setSelectedTradingAccountId(item.investAccount.account.id));
        navigation.navigateDeprecated('InvestPortfolio');
    }, [item.investAccount.account.id]);
    return (<View style={[styles.wrapper, borderStyles]}>
      <TouchableHighlight activeOpacity={1} onPress={onPress} style={borderStyles} underlayColor={colors.background.underlay}>
        <View style={styles.row}>
          <IconEmmaWallet />
          <View style={styles.flex}>
            <Text Text-16 numberOfLines={2}>
              {AccountTypeDisplay[item.investAccount.account.accountType]}
            </Text>
          </View>
          {!!item.investAccount.account.portfolioValue && (<Amount Numbers-16 value={item.investAccount.account.portfolioValue}/>)}
        </View>
      </TouchableHighlight>
    </View>);
};
const WealthInfoRow = ({ item }) => {
    if ('sectionTitle' in item) {
        return (<SectionHeader largeVerticalMargins horizontalMargins>
        {item.sectionTitle}
      </SectionHeader>);
    }
    if ('pot' in item) {
        return <WealthPotRow item={item}/>;
    }
    if ('investAccount' in item) {
        return <WealthInvestAccountRow item={item}/>;
    }
    return null;
};
const styleSet = createStyleSheets((colors) => ({
    wrapper: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: rem(16),
        gap: rem(16),
    },
    flex: {
        flex: 1,
    },
}));
export default WealthInfoRow;
